import { z } from 'zod';
import { servicesProviderPricingSchema, servicesProviderPricingDtoSchema } from '../ServicesProviderPricing.js';
import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Pricing Schemas
// ============================================================================
const platformServicePricingSchema = servicesProviderPricingSchema;
const platformServicePricingDtoSchema = servicesProviderPricingDtoSchema;
// ============================================================================
// Core Schema
// ============================================================================
const platformServiceConfigSchema = serviceConfigSchema.extend({
    pricing: z.array(platformServicePricingSchema),
});
// ============================================================================
// DTO Schema
// ============================================================================
const platformServiceConfigDtoSchema = serviceConfigSchema.extend({
    pricing: z.array(platformServicePricingDtoSchema),
});

export { platformServiceConfigDtoSchema, platformServiceConfigSchema, platformServicePricingDtoSchema, platformServicePricingSchema };
//# sourceMappingURL=PlatformServiceConfig.js.map
